import { DialogTitle } from '@radix-ui/react-dialog'
import clsx from 'clsx'
import React from 'react'

import { DismissButton } from './DismissButton'

const HEADING_SIZES = {
  small: 'heading-sm',
  medium: 'heading-md',
  large: 'heading-lg',
}

const DISMISS_BUTTON_WRAPPER_SIZES = {
  small: 'h-7 xs:h-6',
  medium: 'h-8 xs:h-7',
  large: 'h-[2.375rem] xs:h-8',
}

interface TitleProps extends Omit<React.HTMLAttributes<HTMLHeadingElement>, 'className'> {
  children: React.ReactNode;
  dismissible?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export function Title ({
  children,
  dismissible = true,
  size = 'medium',
  ...props
}: TitleProps) {
  return (
    <div className='flex items-start justify-between gap-2'>
      <DialogTitle
        {...props}
        className={clsx('text-gray-800', HEADING_SIZES[size])}
      >
        {children}
      </DialogTitle>
      {dismissible && (
        <div
          className={clsx(
            'flex items-center',
            DISMISS_BUTTON_WRAPPER_SIZES[size]
          )}
        >
          <DismissButton />
        </div>
      )}
    </div>
  )
}

Title.displayName = 'Modal.Title'
